export const DOMAIN = 'organizationsList';
